import axios from "axios";
const dominio =  import.meta.env.VITE_API_URL;
const onlyPublish = false;
const local = onlyPublish ? false : location.hostname == "localhost";



export const clientBackOffice = axios.create({
  baseURL: local ? "https://localhost:7228/" : dominio + "/backoffice",

});
export const clientCadastro = axios.create({
  baseURL: local ? "https://localhost:7225/" : dominio + "/cadastro",

});
export const clientMapaMina = axios.create({
  baseURL: local ? "https://localhost:7260/" : dominio + "/pesquisa",

});

export const clientSimulador = axios.create({
  baseURL: local ? "https://localhost:7027/" : dominio + "/simulador",

});

export const clientTabelaPreco = axios.create({
  baseURL: local ? "https://localhost:7027/" : dominio + "/simulador",

});

export const clientFunilObras = axios.create({
  baseURL: local ? "https://localhost:7261/" : dominio + "/funil",

});

export const clientRoteirizacao = axios.create({
  baseURL: local ? "https://localhost:7171/" : dominio + "/rota",

});
